module.exports = __webpack_public_path__ + "img/verification.6b8d4af4.gif";